import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { EmploymentEntityIndex } from '@funnels/types';

import { DropdownField } from '../../Fields';

export const OPTIONS = [
  { label: 'Full time', value: FIELD_VALUES.FULL_TIME },
  { label: 'Part time', value: FIELD_VALUES.PART_TIME },
  { label: 'Casual', value: FIELD_VALUES.CASUAL },
  { label: 'Contractor', value: FIELD_VALUES.CONTRACTOR },
  { label: 'Currently on Maternity Leave', value: FIELD_VALUES.MATERNITY_LEAVE },
];

interface EmploymentBasisProps extends EmploymentEntityIndex {
  shouldHideMaternityLeaveOption?: boolean;
  isDisabled?: boolean;
  isOptional?: boolean;
}

export const EmploymentBasis = (props: EmploymentBasisProps) => {
  const { employmentIndex, shouldHideMaternityLeaveOption = false, ...rest } = props;

  return (
    <DropdownField
      {...rest}
      name={FIELD_PATHS.EMPLOYMENT_EMPLOYMENT_BASIS(employmentIndex)}
      label="Employment basis"
      options={OPTIONS.filter(
        (option) => !shouldHideMaternityLeaveOption || option.value !== FIELD_VALUES.MATERNITY_LEAVE
      )}
      validationFailMessage="Please select the employment basis"
    />
  );
};
